import {inject} from '@angular/core';
import {Router} from '@angular/router';
import {map} from 'rxjs/operators';
import {HealthcheckResult, HealthcheckService} from './healthcheck.service';
import {ROOT_ROUTE} from '../application-core.providers';

export function guardBackendStatus() {
  return () => {
    const healthcheckService = inject(HealthcheckService);
    const router = inject(Router);
    const rootRoute = inject(ROOT_ROUTE);

    return healthcheckService.getBackendHealthcheckResult().pipe(
      map((backendStatus: HealthcheckResult) => {
        if (backendStatus.isUp) {
          return true;
        } else {
          if (backendStatus.redirectTo) {
            return router.createUrlTree([
              backendStatus.redirectTo
            ]);
          }
          else {
            return router.createUrlTree([
              rootRoute
            ]);
          }
        }
      }),
    );
  };
}
